<div class="header">
  <span class="title">AFP Configuration</span>
  </div>
<div class="afp-config-container panel-padding">
  <div class="form-row">
    <div class="label-with-info">
      <span class="lable-up-text">Advanced File Parser Configuration</span>
      <img class="info-icon" src="assets/images/info-icon.svg" alt="info" />
    </div>
    <div class="selector-flex">
      <select class="ltms-std-req-dropdown" [(ngModel)]="selectedConfigName" (ngModelChange)="onSelectConfig($event)">
        <option [ngValue]="''" disabled>Select a Configuration</option>
        <option *ngFor="let key of afpConfigKeys" [ngValue]="key">{{ key }}</option>
      </select>
    </div>
      <!-- <button class="delete-config-btn" [disabled]="!isAllowedDeleteAFPConfig || !selectedConfigName" (click)="openDeleteModal()">Delete</button> -->
  </div>
  <div class="loading" *ngIf="isLoading">
    Loading configurations...
  </div>
  <div class="error" *ngIf="isError">
    {{ errorMsg }}
  </div>

  <div class="details" *ngIf="!isLoading && !isError && selectedConfigDetails">
    <app-ltms-data-table-v2 [ngStyle]="{ 'white-space': 'normal' }" [columns]="tableHeaders" [data]="tableRows"></app-ltms-data-table-v2>
  </div>

  <!-- <div class="modal modal-dialog-centered" *ngIf="showDeleteModal" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content login-pop-up-field">
        <div class="modal-header">
          <span class="modal-title login-pop-up-header">{{deleteModalHeader}}</span>
        </div>
        <div class="modal-body login-pop-up-summary">{{deleteModalBody}}</div>
        <div class="modal-footer">
          <button type="button" class="proceed-config-btn" (click)="proceedDelete()">Yes</button>
          <button type="button" class="cancel-config-btn" (click)="cancelDelete()">No</button>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Overlay -->
<div class="afp-modal-overlay" *ngIf="showDeleteModal"></div>
<!-- Centered modal -->
<div class="afp-modal-popup" *ngIf="showDeleteModal">
  <div class="afp-modal-content">
    <div class="afp-modal-title">{{deleteModalHeader}}</div>
    <div class="afp-modal-message">
      {{deleteModalBody}}
    </div>
    <div class="afp-modal-buttons">
      <button class="afp-modal-btn afp-modal-btn-yes" (click)="proceedDelete()" [disabled]="isDeleteDisabled" >Yes</button> // needs to be remove disabled after enable delete button
      <button class="afp-modal-btn afp-modal-btn-no" (click)="cancelDelete()">No</button>
    </div>
  </div>
</div>

  <div class="no-config" *ngIf="!isLoading && !isError && !selectedConfigDetails && afpConfigKeys?.length === 0">
    No configurations available.
  </div>
</div>


